import PropTypes from 'prop-types';


/**
 * The proptype shape of the token package object.
 * This represents a purchasable item in VIA.
 */
export const tokenPackageShape = PropTypes.shape({
  code: PropTypes.number.isRequired,
  description: PropTypes.string,
  packageStartDate: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  mainTokens: PropTypes.number.isRequired,
  extraTokens: PropTypes.number.isRequired,
});

/**
 * Keeps only credit packages that are using the same currency as selectedCurrencyCode.
 * @param {array} creditPackages An array of Token Credit Packages
 * @param {string} selectedCurrencyCode The currency being used.
 */
export const filterCreditPackages = (creditPackages, selectedCurrencyCode) => {
  if (!creditPackages) return creditPackages;
  if (!selectedCurrencyCode) return [];

  return creditPackages.filter(p => p.currencyCode === selectedCurrencyCode);
};


/**
 * Creates a string of all the credit package ids.
 * Reasoning:
 *  We have effects that depend on the change of loaded packages.
 *  However, if we compare the array object, it's always different!
 *  We need to compare the internal ids. Annoying...
 *
 * @param {array} creditPackages An array of credit token packages
 * @return A concatenation of all the ids.
 */
export const createPackagesHash = (creditPackages) => {
  if (!creditPackages) return null;
  return creditPackages.map(p => p.code).join('');
};
